

<form id="general-information" [formGroup]="regForm" (ngSubmit)="step1Submitted(regForm)" novalidate>


  <div class="form-row">

<div class="col-lg-3">
  <label style="font-weight: bold; font-size: x-large;">{{'Step1-General.TranslationSection.text1' | translate}}</label>
</div>

</div><br><br>



<div class="row">
  <div class="col-lg-3">
      <div class="form-group">
        <label>{{'Step1-General.TranslationSection.text2' | translate}}</label>
        <select id="pos" class="form-control" (change)="getWizardStepsChild()"  for="position" formControlName="position" [ngClass]="{'form-submitted': isSubmitted}">
          <option [ngValue]=null>{{'Step1-General.TranslationSection.text3' | translate}}</option>
          <option *ngFor="let position of positions"  [ngValue]="position.value">{{position.name}}</option>
        </select>
      </div>
  </div>

  <div class="col-lg-3">
      <div class="form-group">
        <label >{{'Step1-General.TranslationSection.text4' | translate}}</label>
      <input type="text" class="form-control" for="fname" formControlName="firstName" id="fname" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
      </div>
  </div>

  
  <div class="col-lg-3">
    <div class="form-group">
      <label>{{'Step1-General.TranslationSection.text5' | translate}}</label>
      <input type="text" class="form-control" for="lname"  formControlName="lastName" id="lname" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
    </div>
</div>



<div class="col-lg-3">
  <div class="form-group">
    <label>{{'Step1-General.TranslationSection.text6' | translate}}</label>

    <div class="form-check form-check-inline">
      XXX-XX-
      <input type="text" class="form-control" style= "width:60px;" for="last4"  id="last4"  formControlName="last4Ss" placeholder=""  maxlength="4" [ngClass]="{'form-submitted': isSubmitted}">
    </div>
  </div>
</div>

</div>






<div class="row">

  <div class="col-lg-4">
      <div class="form-group">
        <label>{{'Step1-General.TranslationSection.text7' | translate}}</label>
        <input type="text" class="form-control" for="primaryPhone"  formControlName="primaryPhone" id="primaryPhone" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000' >
      </div>
  </div>

  <div class="col-lg-4">
      <div class="form-group">
        <label>{{'Step1-General.TranslationSection.text8' | translate}}</label>
        <input type="text" class="form-control" for="secondaryPhone"  formControlName="secondaryPhone" id="secondaryPhone" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000' >
      </div>
  </div>

  
  <div class="col-lg-4">
    <div class="form-group">
      <label>{{'Step1-General.TranslationSection.text9' | translate}}</label>
      <input type="email" class="form-control" for="eMail"  formControlName="eMail" id="eMail" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" [readonly]="true">
    </div>
</div>

</div>





<div class="row">

  <div class="col-lg-3">
    <div class="form-group">
      <label>{{'Step1-General.TranslationSection.text10' | translate}}</label>
      <select id="priLanguage" class="form-control" (change)="toggleOfficeSearch($event)"  for="priLanguage" formControlName="priLanguage" [ngClass]="{'form-submitted': isSubmitted}">
        <option [ngValue]=null>{{'Step1-General.TranslationSection.text11' | translate}}</option>
        <option *ngFor="let lang of planguage" [ngValue]="lang.value">{{lang.name}}</option>
      </select>
    </div>
  </div>



  <div class="col-lg-3">
    <div class="form-group">
      <label>{{'Step1-General.TranslationSection.text12' | translate}}</label>
      <select id="howDidYouHearId" class="form-control" for="howDidYouHearId" formControlName="howDidYouHearId" [ngClass]="{'form-submitted': isSubmitted}">
        <option [ngValue]=null>{{'Step1-General.TranslationSection.text13' | translate}}</option>
       <option *ngFor="let howhear of howheartypes" [ngValue]="howhear.value">{{howhear.name}}</option>
       
      </select>
    </div>
</div>


  <div class="col-lg-3">
      <div class="form-group">
        <label>{{'Step1-General.TranslationSection.text14' | translate}}</label>
        <input type="text" class="form-control" for="referredBy"  formControlName="referredBy" id="referredBy" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
      </div>
  </div>

<div class="col-lg-3">
    <div class="form-group">
      <label>{{'Step1-General.TranslationSection.text15' | translate}}<br> (<b>{{'Step1-General.TranslationSection.text16' | translate}}</b> {{'Step1-General.TranslationSection.text17' | translate}})</label>
      <select id="branchId" class="form-control" for="branchId" (change)="getWizardStepsChild()"  formControlName="branchId" [ngClass]="{'form-submitted': isSubmitted}" required [attr.disabled]="true">
        <option [ngValue]=null>{{'Step1-General.TranslationSection.text18' | translate}}</option>
        <option *ngFor="let branch of branchList" [ngValue]="branch.value">{{branch.name}}</option>
      </select>
    </div>
</div>


<!--
  md changes
    <div  class="col-lg-3" >
    <div class="form-group">
      <label>Office Closest<br> (<b>"read only"</b> choose your office from the search box below)</label>
      <select id="branchId" class="form-control" for="branchId" (change)="getWizardStepsChild()"  formControlName="branchId" [ngClass]="{'form-submitted': isSubmitted}"  [attr.disabled]="true">
        <option [ngValue]=null>Please Choose...</option>
        <option *ngFor="let branch of branchList" [ngValue]="branch.value">{{branch.name}}</option>
      </select>
    </div>
</div>


<div class="col-lg-3">
  <div class="form-group">
    <label>How did you hear about us?:</label>
    <select id="howDidYouHearId" class="form-control" for="howDidYouHearId" formControlName="howDidYouHearId" [ngClass]="{'form-submitted': isSubmitted}">
      <option [ngValue]=null>Please Choose...</option>
      <option *ngFor="let howhear of howheartypes" [ngValue]="howhear.value">{{howhear.name}}</option>
    </select>
  </div>
</div>

-->



</div>



<div class="row" style="height:10px;"></div>

<div class="row">
  
  <div class="col-lg-8">
      <div class="form-group">
      
        <label style="font-weight: bold; font-size: larger;">{{'Step1-General.TranslationSection.text19' | translate}}</label><br>


      </div>
  </div>

</div>


<div class="row">
  
  <div class="col-lg-8">
      <div class="form-group">
      
        <label  style="display: inline-block;text-align: left;">(<b>{{'Step1-General.TranslationSection.text20' | translate}}</b>) <br>{{'Step1-General.TranslationSection.text21' | translate}}</label>
        <input type="text" [attr.disabled]="officesearchdisabled ? '' : null"  class="form-control" for="zipinput"  id="zipinput" (input)="somethingChanged($event.target.value)" maxlength="200" placeholder="Please enter your zip code" [ngClass]="{'form-submitted': isSubmitted}" required> 

      </div>
  </div>

</div>



<div class="row" style="height:50px;"></div>





<div class="row">
  
  <div class="col-lg-8">
      <div class="form-group">
   
        <div style="overflow-y: scroll; overflow-x: hidden; height:300px; border-width: thin; border-bottom: 2px solid #7b88d1;border-bottom-width: thin; background-color: #f5f4f4;">

          <div *ngIf="isfetchingBranches === true"><div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetchingBranches === true"></div>
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetchingBranches === true"> Fetching Branches...</i>
         </div> 
       
         <div *ngIf="isfetchingBranches !== true">
         <div   *ngFor="let itemRow of this.officeList.controls.blist.value.controls; let i = index;">
       
       
           <input type="checkbox" 
           [value]="itemRow.value.OfficeName" 
           [checked]="itemRow.value.OChecked"
           (click)="Selection($event.target.checked, itemRow.value.OfficeCode);">&nbsp;
       
       
           <label style="font-weight: bold;">{{itemRow.value.OfficeName}}</label>&nbsp;
          
           <label>{{itemRow.value.Address}}</label>&nbsp;
       
           <label>{{itemRow.value.Distance}}</label>
           
         
        
            </div>
           </div>
         </div>

      </div>
  </div>

</div>



  <span>


<div class="container-fluid">
    <div class="row" >
      <footer >
        <b>{{'Step1-General.TranslationSection.text22' | translate}}</b> <b> {{'Step1-General.TranslationSection.text23' | translate}} </b> {{'Step1-General.TranslationSection.text24' | translate}}<b><u>{{'Step1-General.TranslationSection.text25' | translate}}</u> </b>
        {{'Step1-General.TranslationSection.text26' | translate}}
        </footer>
      </div>
    
    </div><br>



<button type="submit" class="btn btn-primary"  >{{'Step1-General.TranslationSection.text27' | translate}} &nbsp;</button> &nbsp;


  <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> Saving Data...</i>


</span>
  
</form>





